import bog from './moreBog';

export const setItem = (storage, key, value) => storage &&
  storage.setItem(key, JSON.stringify(value));

export const getItem = (storage, key) => {
  let item;
  try {
    item = JSON.parse(storage && storage.getItem(key));
  } catch (err) {
    item = '';
    bog.error(err);
  }
  return item;
};
